import createActionCreators from '_utils/create-action-creators'

export default createActionCreators('DASHBOARD')
